import { createSelector } from '@ngrx/store';
import { prepareSearchModalRecentSearchList } from '../../adapters/search-modal/search-modal-recent-search.adapter';
import { prepareSearchModalSavedSearchList } from '../../adapters/search-modal/search-modal-saved-search.adapter';
import { prepareSearchModalTabs } from '../../adapters/search-modal/search-modal-tabs.adapter';
import { getBookWidgetAem } from './aem.selectors';
import { getBookWidgetFields } from './book-widget.selectors';
import { getPredictiveSearchListWithFilter } from './predictive-search.selectors';
import { getRetrieveSearchDataList } from './retrieve-search.selectors';
import { getSavedSearchDataList } from './saved-search.selectors';

export const getSearchModalTabs = createSelector(
  getBookWidgetAem,
  getRetrieveSearchDataList,
  getSavedSearchDataList,
  getBookWidgetFields,
  (
    bookWidgetAem,
    retrieveSearchDataList,
    savedSearchDataList,
    bookWidgetFields
  ) =>
    prepareSearchModalTabs(
      bookWidgetAem,
      retrieveSearchDataList,
      savedSearchDataList,
      bookWidgetFields
    )
);

export const getSearchModalRecentSearchList = createSelector(
  getBookWidgetAem,
  getRetrieveSearchDataList,
  (bookWidgetAem, retrieveSearchDataList) =>
    prepareSearchModalRecentSearchList(bookWidgetAem, retrieveSearchDataList)
);

export const getSearchModalSavedSearchList = createSelector(
  getSavedSearchDataList,
  (savedSearchDataList) =>
    prepareSearchModalSavedSearchList(savedSearchDataList)
);

export const getSearchModalPredictiveSearchList = createSelector(
  getPredictiveSearchListWithFilter,
  (predictiveSearchList) => predictiveSearchList
);
